import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TestQueryParam, TestType } from '@app/pages/test-runner/interface';

export const testRunnerParamsGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const testType = route.queryParamMap.get(TestQueryParam.TYPE);

  if (!testType) {
    return router.navigate(['/']);
  }

  if (!Object.values(TestType).includes(testType as TestType)) {
    return router.navigate(['/']);
  }

  return true;
};
